import Layout from "./components/Layout/Layout";
import Home from "./pages/Home/Home";
import { useStore } from "./hooks";
import BasaksehirManagement from "./pages/Basaksehir/BasaksehirManagement";
import relativeTime from "dayjs/plugin/relativeTime";
import dayjs from "dayjs";
import "dayjs/locale/tr";
dayjs.locale("tr");
dayjs.extend(relativeTime);

const App = ({ routes }) => {
  const { auth } = useStore();
  const basaksehirRole = auth?.user?.roles?.some((role) =>
    role.includes("observer")
  );
  return (
    <Layout routes={routes}>
      {basaksehirRole ? <BasaksehirManagement /> : <Home />}
    </Layout>
  );
};
export default App;
